// src/features/records/components/CalendarView/MonthView/CalendarGrid.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import DayCell from './DayCell';
import { getWeekdayNames } from '../utils/dateHelpers';
import { getCalendarGridData } from '../utils/calendarData';
import styles from './CalendarGrid.module.css';

const CalendarGrid = ({ 
  records, 
  currentMonth, 
  onDayClick, 
  onRecordClick,
  userProfiles = {},
  profilesLoading = false
}) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  const weekdayNames = getWeekdayNames({ locale });
  const { weeks } = getCalendarGridData(records, currentMonth);
  
  return (
    <div
      className={styles.calendarGrid}
      role="grid"
      aria-label={t('records.views.calendar.grid_aria')}
    >
      {/* Weekday headers */}
      <div className={styles.weekdayRow} role="row">
        {weekdayNames.map((day) => (
          <div 
            key={day} 
            className={styles.weekdayHeader}
            role="columnheader"
            aria-label={day}
          >
            {day}
          </div>
        ))}
      </div>
      
      {/* Calendar weeks */}
      {weeks.map((week, weekIndex) => (
        <div key={weekIndex} className={styles.weekRow} role="row">
          {week.map((day) => (
            <DayCell
              key={day.dateKey}
              date={day.date}
              records={day.records}
              isToday={day.isToday}
              isCurrentMonth={day.isCurrentMonth}
              onDayClick={onDayClick}
              onRecordClick={onRecordClick}
              userProfiles={userProfiles}
              profilesLoading={profilesLoading}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CalendarGrid;
